import * as React from 'react';
import classnames from 'classnames';
import { DataLayer } from '@grandvisionhq/analytics';
import { LocationSearch } from '@grandvisionhq/locations';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';
import '@swc/helpers';
import '@grandvisionhq/utils';
import 'lodash/deburr';
import { useStoreFinderSlots } from '../../context/StoreFinderSlots/context.js';
import { storesSearchFilterEvent } from '../../data-layer/actions.js';
import useStoreSearchFilters from '../../hooks/use-store-search-filters.js';
import { useTabs } from '../../hooks/use-tabs.js';
import { StoreFinderFilterWarning } from '../StoreFinderFilterWarning/StoreFinderFilterWarning.js';
import StoreFinderItemContainer from '../StoreFinderItem/StoreFinderItemContainer.js';
import StoreFinderMapContainer from '../StoreFinderMap/StoreFinderMapContainer.js';
import { StoreListTopContentFallback } from '../StoreListTopContentFallback/StoreListTopContentFallback.js';
import { StoreSearchFilters } from '../StoreSearchFilters/StoreSearchFilters.js';
import StoreSearchFormContainer from '../StoreSearchForm/StoreSearchFormContainer.js';

const StoreFinderContainer = ({ isInsideModal , listTopContent , listInfoContent , listItemComponent , infoWindowContentComponent , buttonsComponent , storeSearchFilters: propStoreSearchFilters , highlightPreferredStore , className , showAttributesAsTags ,  })=>{
    const { isStoresLoading , stores , config , setHoveredStore  } = useStoreFinderContext();
    const showTabs = useTabs();
    const { Slots  } = useStoreFinderSlots();
    const [{ setFilterActivity , applyActiveFilters , clearAllFilters  }, { storeSearchFilters , storeSearchFilterList , hasActiveFilters , loading , activeFilters  }, ] = useStoreSearchFilters({
        filters: propStoreSearchFilters
    });
    const { googleMapsId  } = config;
    const prevActiveFilters = React.useRef([]);
    const showListTopContent = Boolean(listTopContent);
    const showListInfoContent = Boolean(listInfoContent);
    const ButtonsComponent = buttonsComponent;
    const onMouseEnterHandler = React.useCallback((store)=>setHoveredStore(store)
    , [
        setHoveredStore
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>setHoveredStore(null)
    , [
        setHoveredStore
    ]);
    const ListItemComponent = listItemComponent !== null && listItemComponent !== void 0 ? listItemComponent : StoreFinderItemContainer;
    const filteredStores = React.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    React.useEffect(()=>{
        if (prevActiveFilters.current.length !== activeFilters.length) {
            prevActiveFilters.current = activeFilters;
            const dataLayerEvent = storesSearchFilterEvent({
                activeFilters,
                searchResults: filteredStores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        activeFilters,
        filteredStores.length
    ]);
    return /*#__PURE__*/ React.createElement(LocationSearch, {
        className: classnames('store-finder-stores-v2', className, {
            'store-finder-stores-v2--modal': isInsideModal
        }),
        googleMapsId: googleMapsId,
        showTabs: showTabs,
        searchForm: /*#__PURE__*/ React.createElement(StoreSearchFormContainer, {
            queryResultsFilters: stores.length ? /*#__PURE__*/ React.createElement(StoreSearchFilters, {
                filters: storeSearchFilterList,
                setFilterActivity: setFilterActivity
            }) : null
        }),
        listTopContent: /*#__PURE__*/ React.createElement(React.Fragment, null, (Slots === null || Slots === void 0 ? void 0 : Slots.SideComponents) ? /*#__PURE__*/ React.createElement(Slots.SideComponents, null) : null, showListTopContent ? listTopContent : /*#__PURE__*/ React.createElement(StoreListTopContentFallback, null)),
        listInfoContent: showListInfoContent ? listInfoContent : /*#__PURE__*/ React.createElement(StoreFinderFilterWarning, {
            applyActiveFilters: applyActiveFilters,
            clearAllFilters: clearAllFilters,
            hasActiveFilters: hasActiveFilters
        }),
        loadingListItems: isStoresLoading,
        listItems: stores.length ? filteredStores.map((store)=>/*#__PURE__*/ React.createElement(ListItemComponent, {
                loading: loading,
                key: store.code,
                store: store,
                buttons: ButtonsComponent ? /*#__PURE__*/ React.createElement(ButtonsComponent, {
                    store: store,
                    view: "list"
                }) : undefined,
                onMouseEnter: onMouseEnterHandler,
                onMouseLeave: onMouseLeaveHandler,
                showAttributesAsTags: showAttributesAsTags
            })
        ) : [],
        mapContent: /*#__PURE__*/ React.createElement(StoreFinderMapContainer, {
            stores: filteredStores,
            infoWindowContentComponent: infoWindowContentComponent,
            buttonsComponent: ButtonsComponent,
            showAttributesAsTags: showAttributesAsTags
        }),
        highlightPreferredStore: highlightPreferredStore
    });
};

export { StoreFinderContainer as default };
//# sourceMappingURL=StoreFinderContainer.js.map
